export default __webpack_public_path__ + "static/media/anurag.e90a36a7.png";